import type { ComponentProps } from 'react'
import { cn } from '#src/cn.ts'

export function TypographyDetail({
  className,
  ...props
}: ComponentProps<'span'>) {
  return (
    <span
      className={cn('font-medium text-xs leading-4', className)}
      {...props}
    />
  )
}
